module.exports = __webpack_public_path__ + "img/img0624.d71ca397.jpg";